module.exports = __webpack_public_path__ + "img/wish-banner.f4f1ad5c.png";